import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import styles from '../AccountingSystemOpen.module.scss';

const { MaterialSymbol, BodyText, withStyles } = vp;
const cn = withStyles(styles);

export default function ElinxInfoBanner({ type }: { type: 'Payable' | 'Receivable' }) {
  const { t } = useTranslation('translations', { keyPrefix: 'AccountingSystem.OpenTab.Elinx' });

  return (
    <div className={cn('elinxInfoBanner')}>
      <MaterialSymbol icon="info" size="20px" color="#2f82ff" fillAmount={0} />
      <BodyText size="sm" className={cn('elinxInfoBannerText')}>
        {type === 'Receivable'
          ? t('infoBanner_Receivable', {
              defaultValue:
                'eCollect experience will be sent to the customer to securely enter their payment details and complete this collection.',
            })
          : t('infoBanner_Payable', {
              defaultValue:
                'ePay experience will be sent to the supplier to securely enter their payment details and complete this payment.',
            })}
      </BodyText>
    </div>
  );
}
